import { useEffect, useRef } from 'react'
import { Stomp } from '@stomp/stompjs'
import { getWebSocketUrl } from '../../../../../../_metronic/helpers/webSocketHelper'
import { useAuth } from '../../../../auth'

/**
 * Assina `/topic/atendimento/informacao/{id}` e avisa o chamador a cada mensagem. O payload é
 * genérico do atendimento e não é lido: quem recebe o aviso recarrega pelo endpoint autorizado.
 */
export const useExamesImagemSocket = (idAtendimento: number | undefined, onAviso: () => void) => {
  const { auth } = useAuth()
  const accessToken = auth?.accessToken
  const callbackRef = useRef(onAviso)
  callbackRef.current = onAviso

  useEffect(() => {
    if (!idAtendimento || !accessToken) return

    const stompClient = Stomp.client(getWebSocketUrl('/socket/atendimento'))
    stompClient.debug = () => undefined

    const onConnect = () => {
      stompClient.subscribe(`/topic/atendimento/informacao/${idAtendimento}`, () => {
        callbackRef.current()
      })
    }

    stompClient.connect({ Authorization: `Bearer ${accessToken}` }, onConnect, () => undefined)

    return () => {
      try {
        stompClient.disconnect()
      } catch {
        // conexão já encerrada
      }
    }
  }, [idAtendimento, accessToken])
}
